import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./LandingPage.scss"

const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="landingPageContainer">
        <div className="col-left">
            <h1>Smart Brain</h1>
            <p>Experience the power of our face detection AI model, which is fast, reliable, and seamlessly integrated into our web application.</p>
            <button onClick={()=>navigate("/detection")} className="landingBtn">Try it out</button>
        </div>
        <div className="col-right">
        <object className='hero-svg' aria-label="svg animtaed picture" data="./brain.svg" type="image/svg+xml"></object>
        </div>
    </div>
  )
}

export default LandingPage